import React from 'react';
import PropTypes from 'prop-types';
import PartnerStudentVariationSummary from './PartnerStudentVariationSummary';
import { toJS } from 'mobx';
import { PartnerStudentVariationListService } from '../../services/CustomerSuccessKpiListService';
import { observer } from 'mobx-react';
import { get } from 'lodash';

class PartnerStudentVariationSummaryContainer extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    typeId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    PartnerStudentVariationListService.load();
  }

  render() {
    const data = toJS(PartnerStudentVariationListService.getSummaryByType(this.props.type, this.props.typeId));
    return (
      <PartnerStudentVariationSummary
        isLoading={
          PartnerStudentVariationListService.fetchCurrent.fetching ||
          PartnerStudentVariationListService.fetchPrevious.fetching
        }
        currentValue={get(data, 'current')}
        previousValue={get(data, 'previous')}
        standardDeviationValue={get(data, 'currentStandardDeviation')}
        formatter={PartnerStudentVariationListService.getFormattedValue}
      />
    );
  }
}

export default observer(PartnerStudentVariationSummaryContainer);
